export default __webpack_public_path__ + "static/media/194537.3b5614a1.jpg";